<div class="container">
  <div class="flex justify-content-end align-items-center">
    <div class="flex align-items-center field datePicker w-column col-3 mr-2 md:col-12">
      <p-calendar
        style="width: 100%;"
        dateMask
        placeholder="Faixa de datas"
        selectionMode="range"
        [formControl]="keywordFormDateRange"
        dateFormat="dd/mm/yy"
        [maxDate]="maxDate"
        [minDate]="minDateField"
        [showIcon]="true"
        inputId="range"
      >
      </p-calendar>
      <i
        *ngIf="keywordFormDateRange.value"
        (click)="clearFilter()"
        id="search-keyword"
        class="ml-2 text-danger pi pi-fw pi-times-circle cursor-pointer"
      >
      </i>
    </div>
  </div>
  <div class="grid dashboard">
    <div class="grid dashboard w-100">
      <card-statistics
        class="col-12 md:col-6 lg:col-3"
        *ngFor="let item of dashboardData"
        [dashboardItem]="item"
      >
      </card-statistics>
    </div>
    <!-- <div class="col-12 lg:col-4 p-4 mt-2 ml-7">
      <chart-insights></chart-insights>
    </div> -->
    <!-- <div class="col-12 lg:col-12">
      <chart-component></chart-component>
    </div> -->
  </div>
</div>
